module.exports = __webpack_public_path__ + "static/media/honda-plus.10113be9.svg";